import { trigger, state, style, transition, animate } from '@angular/animations';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subscription } from 'rxjs';
import { DataNamesDTO } from 'src/app/features/map-features/sections/locations-section/models/DataNamesDTO';
import { LocationCategoryDTO } from 'src/app/features/map-features/sections/locations-section/models/LocationCategoryDTO';
import { LocationDTO } from 'src/app/features/map-features/sections/locations-section/models/LocationDTO';
import { GeneratedLayerService } from 'src/app/features/map-features/sections/locations-section/services/Generated-Layer.service';
import { LocationRelatedService } from 'src/app/features/map-features/sections/locations-section/services/LocationRelated.service';
import { PanelDetailLocationsService } from 'src/app/features/map-features/sections/locations-section/services/Panel-Detail-Locations.service';
import { ConfirmDialogService } from 'src/app/features/ui/atoms/dialogs/confirm-dialog/services/Confirm-Dialog.service';
import { MessageDialogService } from 'src/app/features/ui/atoms/dialogs/message-dialog/services/message-dialog.service';
import { TutorialService } from 'src/app/features/ui/organisms/tutorial/services/tutorial.service';
import { CreateEmptyLocationDTO } from 'src/app/features/shared/helpers/DTO/CreateEmptyLocationDTO';
import { NameToSingularPipe } from 'src/app/features/shared/pipes/NameToSingular.pipe';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';
import { CitronellaActionsService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/CitronellaActions.service';
import { SignalUserService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Signal-User.service';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';
import { MapHelperService } from 'src/services/map-helper.service';
import { LocationsMapService } from 'src/app/features/map-features/sections/locations-section/services/LocationsMap.service';
import { DetailsPanelAllowanceEnum } from 'src/app/features/pages/maps/utils/enums/detailsPanelAllowanceEnum';
import { AllowedDTO } from 'src/app/features/pages/maps/utils/models/allowedDTO';
import { MapRestrictionsService } from 'src/app/features/pages/maps/services/MapRestrictions.service';
import { GeneralLocationsDetailsPopUpComponent } from '../../location-popup-details/general-location-detail-popup/general-location-details-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { RouteSheetUtilService } from 'src/app/features/map-features/ui/organisms/route-sheet/service/RouteSheetUtil.service';
import { RouteSheetService } from 'src/app/features/map-features/ui/organisms/route-sheet/service/RouteSheet.service';

@Component({
  selector: 'service-details',
  templateUrl: './service-details.component.html',
  styleUrls: ['./service-details.component.css'],
  animations: [
    trigger('mostrarHerramientas', [
      state('visible', style({ opacity: 1, height: '*' })),
      state('hidden', style({ opacity: 0, height: '0', overflow: 'hidden', display: 'none' })),
      transition('visible <=> hidden', animate('300ms ease-in-out'))
    ])
  ]
})
export class ServiceDetailsComponent {
  allowedParts: AllowedDTO;

  images: string[] = [];

  locationDTO: LocationDTO = CreateEmptyLocationDTO();

  Address: string = "Obteniendo ubicación...";;
  Keys: string[] = [];
  KeyNames: DataNamesDTO[] = [];
  Values: string[] = [];
  detallesActivo: string[] = [];
  detallesGPS: string[] = [];
  isVisibleDetails: boolean;
  isVisibleBloking: boolean;
  emptyDates: boolean;
  isAdmin: boolean;
  writeOdometer: boolean;
  fullScreen: boolean = false;
  Coords: string;
  hasRelatedData: boolean = false;
  locationCategorySingularName: string;
  isToolButtonPressed: boolean = false;
  dialogDetailsRef: any = null;

  private activeIdentifier: string = null;
  private $GeneralData: Observable<any> = new Observable<any>();
  private $Address: Observable<string> = new Observable<string>();
  private $Keys: Observable<string[]> = new Observable<string[]>();
  private $KeyNames: Observable<DataNamesDTO[]> = new Observable<DataNamesDTO[]>();
  private $Coords: Observable<string> = new Observable<string>();
  private $Values: Observable<string[]> = new Observable<string[]>();
  private $AllowedBloking: Observable<boolean> = new Observable<boolean>();
  private $Images: Observable<string[]> = new Observable<string[]>();
  public isLoading: boolean = false;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  $isVisibleDetails: Observable<boolean> = new Observable<boolean>();

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  roles: string;
  isMapix: boolean = false;
  locationCategory: LocationCategoryDTO;
  suscription_updateLocationOdometer: Subscription;
  suscription_confirmDialogService: any;
  suscription_createBlokingRequest: Subscription;
  suscription_getDataNames: Subscription;
  suscription_getLocationRelatedList: Subscription;
  suscription_getGeneralData: Subscription;
  suscription_coords: Subscription;
  suscription_keys: Subscription;
  suscription_keyNames: Subscription;
  suscription_values: Subscription;
  suscription_getOdometer: Subscription;
  suscription_address: Subscription;
  suscription_getLoading: Subscription;
  suscription_isVisibleDetails: Subscription;
  suscription_getImages: Subscription;

  constructor(
    private sessionService: SessionService,
    private signalUserService: SignalUserService,
    private messageDialogService: MessageDialogService,
    public panelDetalilService: PanelDetailLocationsService,
    private snackBar: MatSnackBar,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private mapHelperService: MapHelperService,
    private tutorialService: TutorialService,
    private generatedLayerService: GeneratedLayerService,
    private notificationsToastService: NotificationsToastService,
    private nameToSingularPipe: NameToSingularPipe,
    private routeSheetUtilService: RouteSheetUtilService,
    private localStorageService: LocalStorageService,
    private locationSectionService: LocationsMapService,
    private routeSheetService: RouteSheetService,
    private mapRestrictionsService: MapRestrictionsService,
    private dialog: MatDialog
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.$GeneralData = this.panelDetalilService.getGeneralData();
    this.suscription_getGeneralData = this.$GeneralData.subscribe((element: LocationDTO) => {
      //reseta el componente si se carga otro de la misma categoria
      if (this.activeIdentifier != null && element != null && this.activeIdentifier != element.identifier) {
        this.clearComponent();
      }

      this.locationDTO = element;

      if (this.locationDTO != null && this.locationDTO.identifier != null) {
        this.setActiveLayer();
        this.locationCategory = JSON.parse(this.localStorageService.getListaCategorias()).find((item) => item.id == this.locationDTO.idLocationCategory);
        var x = Number(this.locationDTO.cordsX);
        var y = Number(this.locationDTO.cordsY);
        if (typeof y === 'number'  && typeof x === 'number' && !isNaN(y) && !isNaN(x)) {
          this.Coords = y.toFixed(4) + "," + x.toFixed(4);
        }else{
          this.Coords = "No disponible";
        }
        // this.getLocationsRelated();
        this.locationCategorySingularName = this.nameToSingularPipe.transform(this.locationCategory.shortName);
        this.generatedLayerService.createLayer(this.locationCategorySingularName, this.locationCategorySingularName +" seleccionado", ["location"+this.locationCategory.name+"ActiveSource"], true);
        this.activeIdentifier = this.locationDTO.identifier;
      }
    });
    this.$Coords = this.panelDetalilService.getCoords();
    this.suscription_coords = this.$Coords.subscribe((element) => {
      this.Coords = "";
      this.Coords = element;
    });

    this.$Keys = this.panelDetalilService.getKeys();
    this.suscription_keys = this.$Keys.subscribe((element) => {
      this.Keys = [];
      this.Keys = element;

      //Crea arrays de detalles del activo
      this.detallesActivo = this.Keys.filter((item) => !item.includes("GPS"));
      this.detallesActivo.sort();
      //Crea arrays de detalles del GPS
      this.detallesGPS = this.Keys.filter((item) => item.includes("GPS"));
      this.detallesGPS.sort();
    });

    this.$KeyNames = this.panelDetalilService.getKeyNames();
    this.suscription_keyNames = this.$KeyNames.subscribe((element) => {
      this.KeyNames = [];
      this.KeyNames = element;
    });
    this.$Values = this.panelDetalilService.getValues();
    this.suscription_values = this.$Values.subscribe((element) => {
      this.Values = [];
      this.Values = element;
    });

    this.$Address = this.panelDetalilService.getAddress();
    this.suscription_address = this.$Address.subscribe((element) => {
      this.Address = "";
      this.Address = element;
    });
    this.$isVisibleDetails = this.panelDetalilService.checkVisibilityPopup();
    this.suscription_isVisibleDetails = this.$isVisibleDetails.subscribe((element) => {
      this.isVisibleDetails = element;
      setTimeout(() => {
        if (this.isVisibleDetails != undefined && this.isVisibleDetails == true) {
          this.tutorialService.startTutorial(["panelDetailLocationTutorial"]);
        }
      }, 1000);
    });
    this.$Images = this.panelDetalilService.getImages();
    this.suscription_getImages = this.$Images.subscribe((element) => {
      this.images = element;
    });
    this.suscription_getLoading = this.panelDetalilService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });

  }

  ngOnInit(): void {
    this.checkingURL();
    this.allowedParts = this.mapRestrictionsService.allowedParts$.getValue();
  }

  ngOnDestroy() {
    this.clearComponent();
    if (this.suscription_getGeneralData)
      this.suscription_getGeneralData.unsubscribe();
    if (this.suscription_coords)
      this.suscription_coords.unsubscribe();
    if (this.suscription_keys)
      this.suscription_keys.unsubscribe();
    if (this.suscription_keyNames)
      this.suscription_keyNames.unsubscribe();
    if (this.suscription_values)
      this.suscription_values.unsubscribe();
    if (this.suscription_getOdometer)
      this.suscription_getOdometer.unsubscribe();
    if (this.suscription_address)
      this.suscription_address.unsubscribe();
    if (this.suscription_getImages)
      this.suscription_getImages.unsubscribe();
    if (this.suscription_getLoading)
      this.suscription_getLoading.unsubscribe();
  }

  clearComponent(){
    if (this.suscription_updateLocationOdometer)
      this.suscription_updateLocationOdometer.unsubscribe();
    if (this.suscription_confirmDialogService)
      this.suscription_confirmDialogService.unsubscribe();
    if (this.suscription_createBlokingRequest)
      this.suscription_createBlokingRequest.unsubscribe();
    if (this.suscription_getLocationRelatedList)
      this.suscription_getLocationRelatedList.unsubscribe();

    if(this.locationCategorySingularName)
      this.generatedLayerService.deleteLayer(this.locationCategorySingularName, this.locationCategorySingularName +" seleccionado");
    if(this.locationCategory != null){
      this.mapHelperService.UpdateLayerGeoJson("location"+this.locationCategory.name+"ActiveSource",this.mapHelperService.Empty_GeoJson);
      this.mapHelperService.MoveLayer("layer-location"+this.locationCategory.name+"Active", "layer-locationsGeneral");
      this.routeSheetService.clearRouteSheetLayers(this.locationCategory.shortName);
    }
    if(this.locationDTO != null && this.locationDTO.identifier != null)
      this.signalUserService.UnsubscribeSignalUserIdentifierService(this.locationDTO.identifier);
  }


  // getLocationsRelated(){
  //   this.suscription_getLocationRelatedList = this.locationRelatedService.GetAllByIdentifier(this.locationDTO.identifier, false).subscribe({
  //     next: (data) => {
  //       if (data.isSuccess) {
  //         if (data.result.listLocationRelated.length > 0)
  //           this.hasRelatedData = true;
  //       }else{
  //         this.hasRelatedData = false;
  //         console.error('Error al obtener locaciones relacionadas');
  //       }
  //     },
  //     error: (error) => {
  //       // TODO marca para complete despues
  //       console.error('Error al obtener ubicaciones relacionadas', error);
  //     }
  //   });
  // }

  OpenWarning(message: string) {
    this.snackBar.open(message, "", {
      duration: 3000,
      horizontalPosition: "center",
      verticalPosition: "bottom",
      //panelClass: "alert"
    });
  }

  removerNoNumero(value: string): string {
    return value.replace(/[^\d.]/g, ""); // Remueve todos los caracteres que no sean números
  }

  getUsableName(keyName: string): string {
    const keyNameObject = this.KeyNames.find((item) => item.keyName == keyName);
    return keyNameObject ? keyNameObject.usableName : keyName;
  }

  //Obtiene la visibilidad según el nombre de la key
  getNameVisibility(keyName) {
    const keyNameObject = this.KeyNames.find(
      (item) => item.keyName === keyName
    );
    return keyNameObject ? keyNameObject.isVisible : true;
  }

  CancelButton() {
    this.panelDetalilService.setVisibilityPopup(false);
    //this.signalUserService.UnsubscribeSignalUserIdentifierService(this.locationDTO.identifier);
    //this.locationsMapService.ResetCamera();
    this.mapHelperService.UpdateLayerGeoJson(
      "location"+this.locationCategory.name+"ActiveSource",
      this.mapHelperService.Empty_GeoJson
    );
    this.mapHelperService.MoveLayer("layer-location"+this.locationCategory.name+"Active", "layer-locationsGeneral");
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.notificationsToastService.showSuccess("Texto copiado al portapapeles", text);
  }

   setActiveLayer() {
    var obj = {
              lat: Number(this.locationDTO.cordsY),
              lng: Number(this.locationDTO.cordsX),
              idntf: this.locationDTO.identifier,
              idLocationCategory: this.locationDTO.idLocationCategory,
              locationCategory: this.locationDTO.locationCategory,
              activeIcon: this.locationDTO.activeIcon
            };
    this.mapHelperService.UpdateActiveLocation(obj);
  }

  toggleToolButton() {
    this.isToolButtonPressed = !this.isToolButtonPressed;
  }

  onEngineerCardClicked() {
    if(!this.locationDTO.responsable)
      return;

    if(this.allowedParts.allowedFeaturesDetailsPanel.includes(DetailsPanelAllowanceEnum.fullOpenTicketResponsible)){
      this.locationSectionService.onFocusPin(this.locationDTO.responsable);
    }else{
      if (this.dialogDetailsRef) {
        this.dialogDetailsRef.close();
        this.dialogDetailsRef = null;
      }
      var popupData = {
        identifier: this.locationDTO.responsable,
        parentCoordX: this.locationDTO.cordsX,
        parentCoordY: this.locationDTO.cordsY,
        FlyToOnOpen: true,
        FlyToParentOnClose: true,
        UpdateActiveLayer: true,
        showRouteToPoint: true,
      };
      
      this.dialogDetailsRef = this.dialog.open(GeneralLocationsDetailsPopUpComponent,
            {
              maxWidth: "98vw",
              maxHeight: "92vh",
              autoFocus: false,
              restoreFocus: false,
              hasBackdrop: false,
              disableClose: true,
              data: popupData,
            }
          );
    }
  }

}
